<mat-card class="price-default-price">
  <mat-card-header style="width: 100%;">
    <mat-card-title>{{ 'repository.default-price' | translate }}</mat-card-title>
    <mat-card-subtitle style="width: 100%;">
      <div style="width: 100%;display: flex; justify-content: space-between;">
        <div>
        </div>
        <div>
          <mat-slide-toggle [(ngModel)]="displayIndexesPrice" labelPosition="before">
            <span>{{ 'label.indexPrice' | translate }}</span>
          </mat-slide-toggle>
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="content-row" *ngFor="let defaultPrice of defaultPrices">
      <label class="content-row-label">{{defaultPrice?.defaultPriceType?.description}}</label>
      <div class="content-row-input" style="display: flex;">
        <span *ngIf="!displayIndexesPrice">{{defaultPrice.price | number :'0.6' :'fr'}}</span>
        <span *ngIf="displayIndexesPrice">{{defaultPrice.indexPrice | number :'0.6' :'fr'}}</span>
        <!-- <input matInput type="number" autocomplete="off" [value]="defaultPrice.price"> -->
        <span matSuffix style="width: 30px; margin-left: 5px;">€/T</span>

      </div>
    </div>

  </mat-card-content>
  <mat-card-actions>

  </mat-card-actions>
</mat-card>